const version = '2.1.1.13';

const buildVersion = '2.1.1.13';
const environment = import.meta.env.VITE_CURRENT_PUBLIC_SERVER_TAG_TYPE;

console.log('LoginBuildVersion:::', buildVersion);

export default {
    version,
    buildVersion,
    requestPath: environment === 'local' ? 'https://www.smartvideomaker.com/' : '',
    // languagePath: environment === 'local' ? `${basePath}language/local.` : `${basePath}media/login_panel/v1/language/local.`,
    languagePath: environment === 'local' ? `language/local.` : `/app/login/login-panel/language/local.`,
    serverPath: environment === 'release' ? 'https://www.flexclip.com' : 'https://www.smartvideomaker.com',
};
